import { useQuery } from '@tanstack/react-query';

import rateCodeService from '~/services/cruises/RateCodeService';

import { rateCodeQueryKeys } from './rateCodeQueryKeys';

const PAGE_SIZE = 100;

export async function getAllRateCodesByCodes(rateCodes: ReadonlyArray<string>) {
  const response = await rateCodeService.getRateCodeList({ rateCodes: rateCodes.join(','), take: PAGE_SIZE });
  const result = [...response.result];
  while (result.length < response.total) {
    const page = await rateCodeService.getRateCodeList({
      rateCodes: rateCodes.join(','),
      take: PAGE_SIZE,
      skip: result.length,
    });
    result.push(...page.result);
  }
  return { ...response, result };
}

export function useGetRateCodesByCodes(rateCodes: ReadonlyArray<string>) {
  return useQuery({
    queryKey: rateCodeQueryKeys.byCodes(rateCodes),
    queryFn: () => getAllRateCodesByCodes(rateCodes),
    enabled: rateCodes.length > 0,
  });
}
